<template>
    <div class="all clearfix">
        <div class="mdCont bgff">
           <div class="grid pb30">
                <div class="screen mt5">
                    <div class="item clearfix"> 
                        <span class="zu clearfix">
                            <span class="name">地区</span>
                            <city @cityCallback="citySelect" :isAutoWidth='true'></city>
                        </span>
                        
                        <span class="zu yujin-text clearfix">
                            <span class="name">时间</span>
                            <span class="drop-down w140">
                                <vue-datepicker-local v-model="time" format="YYYY-MM-DD" :disabled-date="disabledDate" @input="changeTime"/>
                                <!-- <vue-datepicker-local ref="timeSelect" v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate"  show-buttons clearable @clear="selectedDate" @confirm="selectedDate" placeholder="请选择时间"/> -->
                            </span>
                        </span>
                        <!-- <span class="zu yujin-text clearfix">
                            <span class="name">晚报时间</span>
                            <span class="drop-down w140">
                                <vue-datepicker-local v-model="time1" format="YYYY-MM-DD" :disabled-date="disabledDate" @input="changeTime1"/>
                            </span>
                        </span> -->
                    </div>
                </div>
                <div class="warp mt5 clearfix">
                    <div class="warp-body mt10 mh270">
                        <div class="paperWrap clearfix">
                            <div class="paperWrap-li fl">
                                <div class="paperWrap-header morning crff">
                                    <h1 class="fs32">{{curCity}}晨报</h1>
                                    <p>生成时间：{{time1}} 07:00</p>
                                </div>
                                <div class="paperWrap-body bgff">
                                    <div class="no-data" v-if="nodata.mornData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                                    <ul class="article-list">
                                        <li v-for="(item,index) in mornPaperList.list" :key="index">
                                            <h2 class="ovhidden fs16 fw4">
                                                <!-- <router-link :to="{path:'newsDetail',query:{id:item.id,newsType:9,type:4}}"  class="cr33 " target="_blank">{{item.news_title}}</router-link> -->
                                                <a :href="item.news_url"  class="cr33 " target="_blank">{{item.news_title}}</a>
                                            </h2>
                                            <p class="cr77 fs13 mt8">
                                                <span class="mr20" v-if="item.source_name!=''">{{item.source_name}}</span>
                                                <span >{{item.publish_time}}</span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="paperWrap-li fl">
                                <div class="paperWrap-header evening crff">
                                    <h1 class="fs32">{{curCity}}晚报</h1>
                                    <p>生成时间：{{time2}} 17:00</p>
                                </div>
                                <div class="paperWrap-body bgff">
                                    <div class="no-data" v-if="nodata.evenData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                                    <ul class="article-list">
                                        <li v-for="(item,index) in evenPaperList.list" :key="index">
                                            <h2 class="ovhidden fs16 fw4">
                                                <!-- <router-link :to="{path:'newsDetail',query:{id:item.id,newsType:9,type:4}}"  class="cr33 " target="_blank">{{item.news_title}}</router-link> -->
                                                <a :href="item.news_url"  class="cr33 " target="_blank">{{item.news_title}}</a>
                                            </h2>
                                            <p class="cr77 fs13 mt8">
                                                 <span class="mr20" v-if="item.source_name!=''">{{item.source_name}}</span>
                                                <span >{{item.publish_time}}</span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mapChart from '../../components/echart/mapChart'
import Myleft from '../../components/left'
import city from '../../components/city.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components: {mapChart,Myleft,VueDatepickerLocal,city},
    data() {
        return {
            apiSecret : this.$route.query.api_secret,
            hotTopicsList:[],
            showTit:true,
            defaultImg:'this.src="static/images/default.png"',
            tags:'全部',
            curRank:'晨晚报',
            curRankType:1,
            curMedia:'全部',//当前媒体
            mediaList:{'全部':4,'网页':1,'微信':2,'微博':3},//媒体下拉列表
            mornPaperList:[],  //早报
            evenPaperList:[],  //晚报
            curCity:'全国',
            tagsList:[],
            mapChartData:[],//地图数据
            hotAllRank:[], //热点事件
            provinceList:[],//地图省份选择列表
            provinceFullList:[],//地图省份选择列表全称
            curMapName:'全国',//
            curFullName:'全国',//
            pageCur:1,
            pageNum:10,
            dataCount:0,
            timeRange: [],
            time: new Date(),  //时间选择
            time1: new Date(),  //时间选择
            time2: new Date(),  //时间选择
            maxTime:new Date(),
            setTimer:null, //定时器
            province:'',//省份
            city:'',//城市
            county:'',//区县
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                mornData:false,
                evenData:false,
                mapChartData:false,
                hotAllRank:false
            }
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.tags = that.$route.query.type;
            //let newTime = new Date();
            that.initTime();
            that.$utils.screenHeight();
            that.setTime();
        }) 
    },
    beforeDestroy() {
        clearInterval(this.setTimer);
    },
    watch: {
		$route(){
			let that = this;
            that.tags = that.$route.query.type;
            that.$refs.left.curType = that.tags;
            that.clearListData();
		},
	},
    methods: {
        initTime(tim){
            let that = this,newTime = new Date(),nowTime='',today='',curTime='';
            if(tim!=undefined){
                nowTime = that.$utils.dateConversion(tim,0);
                curTime = that.$utils.dateConversion(tim,1);
            }else{
                nowTime = that.$utils.dateConversion(newTime,0);
                curTime = that.$utils.dateConversion(newTime,1);
            }
            today = that.$utils.dateConversion(newTime,0);
            that.time = nowTime;
            let mornT = today +' 07:00:00';
            let evenT = today +' 17:00:00';
            let yesTerday = that.$utils.getBeforeDay(newTime,1);
            let oDate1 = new Date(curTime.replace(/-/g, "/")); //replace(/-/g, "/") 兼容ie浏览器 
            let oDate2 = new Date(mornT.replace(/-/g, "/")); //replace(/-/g, "/") 兼容ie浏览器 
            let oDate3 = new Date(evenT.replace(/-/g, "/")); //replace(/-/g, "/") 兼容ie浏览器 
            if((newTime-oDate1)<60*60*12*1000){
                
                if(oDate1.getTime() < oDate2.getTime()){
                    that.time1 = yesTerday;
                    that.time2 = yesTerday;
                    that.time = yesTerday;
                    that.maxTime = new Date(yesTerday);
                } else {
                    
                    if(oDate1.getTime() > oDate3.getTime()){
                        that.time1 = that.time;
                        that.time2 = that.time;
                        that.maxTime = oDate1;
                    } else {
                        that.time1 = that.time;
                        that.time2 = yesTerday;
                    }
                }
            }else{
                that.time1 = that.time;
                that.time2 = that.time;
            }

            that.mornAjax();
            that.evenAjax();
        },
        //下拉选择
        dropDownChoose(name,type,num){
            let that = this;
            if(num===1){
                that.curRankType = type;
                that.curRank = name;
            }else if(num===2){
                that.curMapName = that.provinceFullList[type]
                that.curProvMapName = that.curMapName;    
            }else{
                that.curMedia = name;
            }
            that.clearListData();
        },
        changeTime(){
            let that = this;
            // that.time1 = that.$utils.dateConversion(that.time,0)
            // that.time2 = that.$utils.dateConversion(that.time,0)
            that.initTime(that.time)
            that.dropDownChoose('晨晚报',1);
        },
        mornAjax(){
            let that = this,tags='';
            tags = (that.tags == '全部')?'':that.tags;
            let datas={
                type:1,
                time:that.time1,
                tag:tags,
                province:that.province,
                city:that.city,
                county:that.county,
                perpage:that.pageNum,
                page:that.pageCur,
                api_secret:that.apiSecret
            };
            //let ws = new WebSocket('ws://apihot.gstai.com/news/index/hot-list-newspaper')
            that.$api.get('news/index/hot-list-newspaper',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.mornPaperList = r.data;
                    if(r.data.list.length<=0){
                        that.nodata.mornData = true;
                    }else{
                        that.nodata.mornData = false;
                    }
                    
                });
            });
        },
        evenAjax(){
            let that = this,tags='';
            tags = (that.tags == '全部')?'':that.tags;
            let datas={
                type:2,
                time:that.time2,
                tag:tags,
                province:that.province,
                city:that.city,
                county:that.county,
                perpage:that.pageNum,
                page:that.pageCur,
                api_secret:that.apiSecret
            };
            that.$api.get('news/index/hot-list-newspaper',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.evenPaperList = r.data;
                    if(r.data.list.length<=0){
                        that.nodata.evenData = true;
                    }else{
                        that.nodata.evenData = false;
                    }
                    
                });
            });
        },
        
        // 地区筛选
        citySelect (name) {
            let province = name[0];
            let city = name[1];
            let that = this;
            let province2 = name[3];
            let city2 = name[2];
            let county = name[4];
            if(province === '全国'){
                that.province = '';
            }else{
                that.province = province;
            }
            that.county = (county === '全市'|| county === '选择区县')?'':county;
            that.city = (city2 === '全市'||city === '全省' || city === '选择城市')?'':city;
            that.curCity = (city2 === '全市'||city2 === '全省' || city2 === '选择城市' || province2 === '全国')?province2:city2;
            if(that.county!=''){
                that.curCity = county;
            }
            that.clearListData();
        },
        
        clearListData(){
            let that = this;
            if(that.curRankType===1){
                that.mornAjax()
                that.evenAjax()
            }else{
                that.hotAllRank = [];
                that.dataAjax();
            }
        },
        disabledDate (time) {
            return time > this.maxTime
            //return time < this.min || time > this.max
        },
        setTime(){
            let that = this;
            that.setTimer = setInterval(function(){
                that.initTime();
            },120000);
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/event/eveningPaperN.vue